const State: any = {};

const mutations: any = {};

const actions: any = {};

const getters: any = {};

export default {
  namespaced: true,
  state: State,
  mutations,
  actions,
  getters,
};
